'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).factory('WorkflowApproval', ['$resource', '$stateParams', 'apiSettings', function ($resource, $stateParams, apiSettings) {
	return $resource(apiSettings.baseUri + 'v1/workflowapprovals/:id', { id: '@id' }, {
		'list': {
			method: 'GET',
			isArray: false,
			params: {
				page: 1,
				pageSize: apiSettings.defaultPageSize,
				keyword: ''
			}
		},
		'update': {
			method: 'PUT'
		},
		'updateColor': {
			url: apiSettings.baseUri + 'v1/workflowapprovals/color',
			method: 'PUT',
		},
		'cancel': {
			url: apiSettings.baseUri + 'v1/workflowapprovals/cancel',
			method: 'POST'
		},
		'complete': {
			url: apiSettings.baseUri + 'v1/workflowapprovals/complete',
			method: 'POST'
		}
	});
}]);